import { defineComponent as _defineComponent } from 'vue'

import type {
  CloseEndedQuestion,
  Content,
  Exercise,
  ExternalReference,
  Instruction,
  OpenEndedQuestion,
} from '@ilteducation/exercise-service-types';
import ShowOpenEnded from '@/components/exercise/ShowOpenEnded.vue';
import ShowCloseEnded from '@/components/exercise/ShowCloseEnded.vue';
import ShowExternalReference from '@/components/exercise/ShowExternalReference.vue';

type Props = {
  id: string;
  title: string;
  item: Exercise;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Show',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
  title: string;
  item: Exercise;
}

const isOpenEndedQuestion = (content: Content): content is OpenEndedQuestion => content.type === 'open-question';
const isExternalReference = (content: Content): content is ExternalReference => content.type === 'external-reference';
const isInstruction = (content: Content): content is Instruction => content.type === 'reflection-task';
const isCloseEndedQuestion = (content: Content): content is CloseEndedQuestion => content.type === 'closed-question';

const getReferenceType = (refType: string) => {
  switch (refType) {
    case 'video':
      return 'videos';
    case 'article':
      return 'articles';
    default:
      return 'books';
  }
};

const getContentChipColor = (refType: string) => {
  if (refType === 'video') return '#B39DDB';
  return '#26A69A';
};


const keyedContent = props.item.content.map((data, id) => ({ data, id }));

return { __sfc: true,isOpenEndedQuestion, isExternalReference, isInstruction, isCloseEndedQuestion, getReferenceType, getContentChipColor, props, keyedContent, ShowOpenEnded, ShowCloseEnded, ShowExternalReference }
}

})